import { useState, useEffect } from 'react';
import { useIntercom as reactUseIntercom } from 'react-use-intercom';

const useIntercom = () => {
  const intercom = reactUseIntercom();
  const [hasBanner, setHasBanner] = useState(false);
  const [bannerSize, setBannerSize] = useState(0);

  useEffect(() => {
    const checkBannerPresence = () => {
      const iframe = document.querySelector<HTMLIFrameElement>(
        'iframe[name="intercom-banner-frame"]'
      );
      setHasBanner(!!iframe);
      setBannerSize(iframe?.clientHeight || 0);

      if (iframe) {
        iframe.style.zIndex = '10000';
      }
    };

    // Initial check
    checkBannerPresence();
    // Set up MutationObserver
    const observer = new MutationObserver(() => {
      checkBannerPresence();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return {
    ...intercom,
    hasBanner,
    bannerSize,
  };
};

export default useIntercom;
